import moment from "moment";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import paginationComponent from "../../components/pagination/pagination.component";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import SelectSiteSearchInputComponent from "../../components/site/select-site-search-input.component";
import SelectUserComponent from "../../components/user/select-user.component";
import { formats as FORMATS } from '../../config/constants';
import IMEISNLogReportModel from "../../models/imei-sn-log-report/imei-sn-log-report.model";
import languageModel from "../../models/language.model";
import loginModel from "../../models/login.model";
import ViewBase from "../view-base.view";

/**
 *  IMEI/SN Log Report view
 * 
 * A page that displays a list of  IMEI/SN Log Report 
 * 
 * @author cmc.pbhieu
 */

export default function IMEISNLogReportView() {
  ViewBase.call(this);

  const results = [
    { code: "True", name: "Success" },
    { code: "False", name: "Fail" }
  ];

  const DEFAULT_FILTERS = Object.freeze({
    fromDate: moment().subtract(6, "days").format(FORMATS.ISO_DATE_FORMAT),
    toDate: moment().format(FORMATS.ISO_DATE_FORMAT),
    countryCode: '',
    site: [],
    promoters: [],
    imei: '',
    message: '',
    result: '',
  });

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
  };

  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);

  let reports = [];

  const getFilterParams = (param) => {
    const sideIds = param.sites ? param.sites.map(site => site.siteId) : [];
    const promoterIds = param.promoters ? param.promoters.map(promoter => promoter.userID) : [];

    return {
      fromDate: moment(param.fromDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
      toDate: moment(param.toDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),

      siteIds: sideIds,
      promoters: promoterIds,

      imei: param.imei,
      remarks: param.message,
      isValid: param.result,

      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
    };
  };

  const onPageSizeChanged = (pageIndex, pageSize) => {
    pagination.pageIndex = pageIndex;
    pagination.pageSize = pageSize;

    search();
  };

  const onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    search();
  };

  const formatData = (data) => {
    return structuredClone(data);
  };

  const search = () => {
    this.showLoading();

    IMEISNLogReportModel.search(getFilterParams(filters)).then(result => {
      reports = [];

      if (result) {
        reports = formatData(result.data);

        pagination.pageIndex = result.pageIndex;
        pagination.pageSize = result.pageSize;
        pagination.totalItems = result.total;
      }
    })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const downloadExcel = () => {
    this.showLoading();

    const fileName = `${loginModel.credentials.country}_IMEI SN LOG Report_${moment().format('YYYYMMDDHHmmss')}`;

    IMEISNLogReportModel.download(getFilterParams(filters), fileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  return {
    oninit: () => {
      search();
    },
    view: () => {
      return [
        ///* SEARCH */
        m(".d-flex.flex-column.align-items-end.gap-2.mb-3",
          m(".card.collapse.show#search-section.w-100",
            m(".card-body",
              m(".row.mb-2.g-4",
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative.gap-2",
                  m('label.form-label[for="datePicker"]', this.getText("LT00000150", "Period")),
                  m(DatePickerComponent, {
                    id: 'datePicker',
                    class: 'form-control',
                    placeholder: this.getText('LT00000895', 'Time Range'),
                    isRange: true,
                    dateStart: filters.fromDate,
                    dateEnd: filters.toDate,
                    calendars: 1,
                    onselect: (event) => {
                      filters.fromDate = event.detail.start;
                      filters.toDate = event.detail.end;
                    }
                  })
                ),

                m('.col-xl-3.col-lg-4.col-sm-6.position-relative.gap-2',
                  m('label.form-label[for="imei"]', this.getText('LT00001117', 'IMEI/SN')),
                  m('input.form-control.form-control-bg',
                    {
                      id: 'imei',
                      value: filters.imei,
                      maxLength: 100,
                      onchange: (e) => { filters.imei = e.target.value.trim(); }
                    })
                ),
              ),

              m(".row.mb-2.g-4",
                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                  m('label.form-label[for="sites"]', this.getText('LT00000071', 'Site')),
                  m(SelectSiteSearchInputComponent, {
                    id: 'sites',
                    multiple: true,
                    selectedItems: filters.sites,
                    onSelect: (selectedItems) => { filters.sites = selectedItems; }
                  })
                ),

                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                  m('label.form-label[for="messsage"]', this.getText('LT00001118', 'Messsage')),
                  m('input.form-control.form-control-bg', {
                    id: 'messsage',
                    value: filters.message,
                    maxLength: 100,
                    onchange: (e) => { filters.message = e.target.value.trim(); }
                  })
                ),
              ),

              m(".row.mb-2.g-4",
                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                  m('label.form-label[for="promoters"]', this.getText('LT00000561', 'Promoter')),
                  m(SelectUserComponent, {
                    id: 'promoters',
                    selectedUserList: filters.promoters,
                    hideMyTeam: true,
                    onSelect: (value) => {
                      filters.promoters = value;
                    }
                  }),
                ),
                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                  m('label.form-label[for="result"]', this.getText('LT00000947', 'Result')),
                  m(SingleSelectComponent, {
                    id: "result",
                    items: results,
                    filterable: false,
                    selectedItem: filters.result,
                    keyOnly: true,
                    onSelect: (item) => {
                      filters.result = item;
                    },
                  }),
                ),

                m(".col-xl-6.col-lg-6.d-flex.align-items-end.justify-content-end.gap-2",
                  m("button.btn.btn-primary",
                    {
                      onclick: () => {
                        pagination = structuredClone(DEFAULT_PAGINATION);
                        search();
                      },
                    },
                    this.getText("LT00000001", "Search")
                  ),
                  m("button.btn.btn-primary",
                    {
                      onclick: downloadExcel,
                      disabled: reports == null || reports.length == 0
                    },
                    m("i.bi.bi-file-earmark-arrow-down-fill"),
                    this.getText("LT00000018", "Excel Download")
                  )
                )
              ),
            )
          )
        ),
        ///* TABLE */
        m(".card",
          m(".card-body",
            m(".row.g-2",
              m(".col-12",
                m(".table-responsive",
                  m("table.table.table-hover.sticky-column-start",
                    m("thead",
                      m("tr.align-middle",
                        m("th.center", this.getText("LT00000049", "User ID")),
                        m("th.center", this.getText("LT00000050", "User Name")),
                        m("th.center", this.getText("LT00001119", "Channel Count")),
                        m("th.center", this.getText("LT00001120", "IMEI/SN Count")),
                        m("th", this.getText("LT00001121", "Check Message")),
                      )
                    ),
                    m("tbody",
                      reports.length == 0 &&
                      m("tr.align-middle",
                        m("td.text-center",
                          { colspan: "21" },
                          languageModel.getText(
                            "EM00000141",
                            "No records found."
                          )
                        )
                      ),
                      reports.length != 0 && reports.map((data, index) =>
                        m(`tr.align-middle`,
                          m("td.center", m("span.cursor-text", data.userId)),
                          m("td.center", m("span.cursor-text", data.userName)),
                          m("td.center", m("span.cursor-tex", data.channelCount)),
                          m("td.center", m("span.cursor-text", data.imeiSnCount)),
                          m("td", m("span.cursor-text", data.checkMessage))
                        )
                      )
                    )
                  )
                )
              ),
              reports.length != 0 &&
              m(".col-12",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  onPageChanged: onPageChanged,
                  onPageSizeChanged: onPageSizeChanged,
                })
              )
            )
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}